
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";


export const AppAlert = ({ 
    caption, 
    message, 
    accept, 
    reject, 
    acceptAction, 
    rejectAction,
    close,
    alerted
}) => {
    return (
        <div className="alertBg">
            <div className={classNames("alert-box",{"on-alert": alerted})}>
                <div className="alert-top">
                    <div className="alert-caption">{caption}</div>
                    
                </div>
                <div className="alert-mid">{message}</div>
                <div className="alert-bottom">
                    {accept &&
                    <button 
                        className={classNames("alert-btn", "accept")}
                        onClick={acceptAction}
                    >
                        {accept}
                    </button>
                    }
                    {reject &&
                        <button 
                            className={classNames("alert-btn", "reject")}
                            onClick={rejectAction}
                        >
                            {reject}
                        </button>
                    }
                </div>
            </div>
        </div>
    );
}